import PeopleIcon from '@mui/icons-material/People';
import KeyViewList from './KeyViewList';

export default {
  list: KeyViewList,
  icon: PeopleIcon,
  recordRepresentation: (record: any) => `${record.last_name}`,
};
